import React from 'react'
import { Provider, connect } from "react-redux"
import trans from 'trans';
import store from "store";
import Mergado from "../helpers/mergado";

import {
    Toast,
    Button,
    Icon,
    confirm,
    Spinner,
    Theme,
    Toasts,
} from "@bdfx/mergado-ui-kit"

import {
    downloadProductsExport,
    hideProductsExport,
    getProductsExport,
    downloadTemplateExport,
    getSimilarityExport,
    getTemplateExport,
    ExportsType
} from "../reducers/exports"

import { URL } from "../config/api-config";
import { Project } from "app/types/model-types";
import { ID } from '@bdfx/mergado-ui-kit/lib/helpers/types';
import ModalProductsExportsWrapper from 'app/components/modal-products-exports-wrapper';
import { ConfirmStyles } from 'load_styles';

interface Props {
    toasts: any[]
    project: Project
    exportProducts: ExportsType
    exportTemplates: ExportsType
    exportSimilarity: ExportsType
    downloadProductsExport: typeof downloadProductsExport
    downloadTemplateExport: typeof downloadTemplateExport
    getProductsExport: typeof getProductsExport
    getTemplateExport: typeof getTemplateExport
    getSimilarityExport: typeof getSimilarityExport
    hideProductsExport: typeof hideProductsExport
}

interface State {
    isCheckingProducts: boolean
    isCheckingTemplates: boolean
    isCheckingSimilarity: boolean
}

class ToastContainer extends React.PureComponent<Props, State> {
    protected checkingProductsExport
    protected checkingTemplatesExport
    protected checkingSimilarityExport

    constructor(props: Props) {
        super(props)

        this.state = {
            isCheckingProducts: null,
            isCheckingTemplates: null,
            isCheckingSimilarity: null,
        }
    }

    protected renderToastList() {
        return this.props.toasts.map((toast, index) => {
            if (typeof toast !== 'undefined') {
                return (<Toast style={{ minWidth: "400px" }} type={toast.type} key={index} icon={toast.icon}>{toast.content}</Toast>)
            } else {
                return <React.Fragment key={index}></React.Fragment>
            }
        })
    }

    startCheckingProductsExport = () => {
        if (!this.props.exportProducts.checking.length) {
            this.stopCheckingProductsExport()
        } else if (!this.state.isCheckingProducts) {
            clearInterval(this.checkingProductsExport)
            this.setState({ isCheckingProducts: true })
            this.checkingProductsExport = setInterval(() => {
                if (this.props.exportProducts.checking.length) {
                    this.props.exportProducts.checking.forEach(c => {
                        this.props.getProductsExport(c)
                    })
                } else {
                    this.stopCheckingProductsExport();
                }
            }, 2000)
        }
    }

    startCheckingTemplatesExport = () => {
        if (!this.props.exportTemplates.checking.length) {
            this.stopCheckingTemplatesExport()
        } else if (!this.state.isCheckingTemplates) {
            clearInterval(this.checkingTemplatesExport)
            this.setState({ isCheckingTemplates: true })
            this.checkingTemplatesExport = setInterval(() => {
                if (this.props.exportTemplates.checking.length) {
                    this.props.exportTemplates.checking.forEach(c => {
                        this.props.getTemplateExport(c)
                    })
                } else {
                    this.stopCheckingTemplatesExport();
                }
            }, 2000)
        }
    }

    startCheckingSimilarityExport = () => {
        if (!this.props.exportSimilarity.checking.length) {
            this.stopCheckingSimilarityExport()
        } else if (!this.state.isCheckingSimilarity) {
            clearInterval(this.checkingSimilarityExport)
            this.setState({ isCheckingSimilarity: true })
            this.checkingSimilarityExport = setInterval(() => {
                if (this.props.exportSimilarity.checking.length) {
                    this.props.exportSimilarity.checking.forEach((id: ID) => {
                        this.props.getSimilarityExport(id)
                    })
                } else {
                    this.stopCheckingSimilarityExport();
                }
            }, 2000)
        }
    }

    stopCheckingProductsExport = () => {
        clearInterval(this.checkingProductsExport)
        this.setState({ isCheckingProducts: false })
    }

    stopCheckingTemplatesExport = () => {
        clearInterval(this.checkingTemplatesExport)
        this.setState({ isCheckingTemplates: false })
    }

    stopCheckingSimilarityExport = () => {
        clearInterval(this.checkingSimilarityExport)
        this.setState({ isCheckingSimilarity: false })
    }

    downloadExport = () => {
        Mergado.startDownload(this.props.exportProducts.data.file_url)
        this.props.downloadProductsExport(this.props.exportProducts.data.id)
        this.props.hideProductsExport()
    }


    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (prevProps) {
            if (prevProps.exportProducts.checking.length === this.props.exportProducts.checking.length && prevProps.exportProducts.checking.length > 0) { //same length, nothing changed so far
                this.startCheckingProductsExport()
            }

            if (prevProps.exportTemplates.checking.length === this.props.exportTemplates.checking.length && prevProps.exportTemplates.checking.length > 0) { //same length, nothing changed so far
                this.startCheckingTemplatesExport()
            }

            if (prevProps.exportSimilarity.checking.length === this.props.exportSimilarity.checking.length && prevProps.exportSimilarity.checking.length > 0) { //same length, nothing changed so far
                this.startCheckingSimilarityExport()
            }

            if ((this.props.exportProducts.isExporting || this.props.exportProducts.isExported) && (
                (prevProps.exportProducts.isExporting !== this.props.exportProducts.isExporting) ||
                (prevProps.exportProducts.checking.length !== this.props.exportProducts.checking.length) ||
                this.props.exportProducts.isExported
            )) {
                confirm({
                    className: 'products-export-modal',
                    title: trans("please_wait_generating_export"),
                    message: (close) => <Provider store={store}><ModalProductsExportsWrapper close={close}/></Provider>,
                    //message: {trans("please_wait_generating_export2"),
                    icon: <Icon type={'cloud-download'} />,
                    onClose: () => this.props.hideProductsExport(),
                    style: ConfirmStyles,
                    buttons: [
                        <React.Fragment key={`confirm-yes_${this.props.exportProducts.data?.progress}`}>
                            {this.props.exportProducts.isExporting ?
                                <Spinner type="dotted" color="blue" size={30} className={'spinner-loader'} /> :
                                <a href={`${URL.laravelBase}exports/${this.props.exportProducts.data.file_name}.csv`} target={"_blank"} download>
                                    <Button className={'export-button'} color={"green"} key="download">{trans("download")}</Button>
                                </a>
                            }
                        </React.Fragment>,
                        <Button
                            key={'confirm-close'}
                            className={'export-button'}
                            style={{ background: Theme.steelblue }}
                            color={Theme.steelblue}
                            onClick={(e) => this.props.hideProductsExport()}
                        >{trans("close")}</Button>
                    ]
                })
            }
        }
    }

    componentDidMount(): void {
        this.stopCheckingProductsExport()
        this.stopCheckingTemplatesExport()
        this.stopCheckingSimilarityExport()
    }

    downloadFromBlob = (blob: any, filename: string) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', filename + '.json');
        document.body.appendChild(link);
        link.click();
    }

    handleCloseToast = (o) => {
        this.props.downloadProductsExport(o.id)
        return false
    }

    handleDownloadTemplateJson = (o) => {
        this.props.downloadTemplateExport(o.id)
        return false
    }

    public render() {
        return (
            <Toasts>
                {this.props.exportProducts.done.map((o, index) => {
                    return <Toast
                        type={"info"}
                        closeable={true}
                        key={`export_index${index}`}
                        onClose={() => this.handleCloseToast(o)}
                        style={{ pointerEvents: 'auto' }}
                        icon={<Icon type={'check'} color={"green"} />}>
                        {trans("export_is_ready")}&nbsp;
                            <a href={`${URL.laravelBase}exports/${o.file_name}.csv`} target={"_blank"} download>
                                <Button type="void" color={"nocolor"}>{trans("download")}</Button>
                            </a>
                        <div><small>{trans("exported")} {trans("n_products", { n: o.rows_total })} za {o.duration + 1} s</small></div>
                    </Toast>
                })}

                {this.props.exportTemplates.done.map((o, index) => {
                        this.props.downloadTemplateExport(o.id) //unsubscribe from done
                        this.downloadFromBlob(o.blob, o.file_name)
                        return <Toast
                            type={"info"}
                            closeable={true}
                            key={index}
                            style={{ pointerEvents: 'auto' }}
                            onClose={() => this.handleDownloadTemplateJson(o)}
                            icon={<Icon type={'check'} color={"green"} />}><div>{trans("export_is_ready")} &nbsp;
                                <a href={`${URL.publicPath}import-export/${o.file_name}.json`} target={"_blank"} download>
                                    <Button type="void" color={"nocolor"}>{trans("download")}</Button>
                                </a>
                            </div>
                            <div><small>{trans("template_exported")}</small></div>
                        </Toast>
                    })}

                    {this.renderToastList()}
                </Toasts>
        );
    }
}

function mapStateToProps(state) {
    return {
        toasts: state.toasts,
        exportProducts: state.exportProducts,
        exportTemplates: state.exportTemplates,
        exportSimilarity: state.exportSimilarity,
        project: state.project.id,
    }
}

export default connect(mapStateToProps, {
    downloadProductsExport,
    downloadTemplateExport,
    getProductsExport,
    getTemplateExport,
    getSimilarityExport,
    hideProductsExport,
})(ToastContainer);
